import * as React from 'react';

import createLoadableComponent from 'js/lib/createLoadableComponent';

import MegaMenuWrapper from 'bundles/page-header/components/desktop/mega-menu/MegaMenuWrapperLite';
import LazyLoadingHandler from 'bundles/page/components/shared/LazyLoadingHandler';

const LoadableMegaMenu = createLoadableComponent(
  () => import('bundles/page-header/components/optimized/MegaMenuContent'),
  LazyLoadingHandler
);

type Props = {
  // Render menu content on server for SEO reasons, used on logged-out homepage.
  renderMenuOnServer?: boolean;
};

const LegacyExploreMegaMenuGridItem = ({ renderMenuOnServer }: Props) => {
  return (
    <MegaMenuWrapper
      renderMenuOnServer={renderMenuOnServer}
      key="MegamenuWrapper"
      LoadableMegaMenu={LoadableMegaMenu}
    />
  );
};

export default LegacyExploreMegaMenuGridItem;
